"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkDeveloperSettingsValidation = exports.getIsFavoriteUser = exports.removeIsFavoriteUser = exports.setIsFavoriteUser = exports.removeToken = exports.getToken = exports.setToken = exports.isAuthenticated = exports.requiresVerification = exports.isVerified = exports.removeUnverifiedEmail = exports.getUnverifiedEmail = exports.setUnverifiedPhoneNumber = exports.setUnverifiedEmail = exports.TOKEN = void 0;
exports.TOKEN = 'token';
var setUnverifiedEmail = function (email) {
    localStorage.setItem('email', email);
};
exports.setUnverifiedEmail = setUnverifiedEmail;
var setUnverifiedPhoneNumber = function (phone) {
    localStorage.setItem('phone', phone);
};
exports.setUnverifiedPhoneNumber = setUnverifiedPhoneNumber;
var getUnverifiedEmail = function () {
    return localStorage.getItem('email');
};
exports.getUnverifiedEmail = getUnverifiedEmail;
var removeUnverifiedEmail = function () {
    localStorage.removeItem('email');
};
exports.removeUnverifiedEmail = removeUnverifiedEmail;
var isVerified = function () {
    return !localStorage.getItem('email');
};
exports.isVerified = isVerified;
var requiresVerification = function () {
    return !!localStorage.getItem('email');
};
exports.requiresVerification = requiresVerification;
var isAuthenticated = function () {
    return !!exports.getToken();
};
exports.isAuthenticated = isAuthenticated;
var setToken = function (token) {
    localStorage.setItem(exports.TOKEN, token);
};
exports.setToken = setToken;
var getToken = function () {
    return localStorage.getItem(exports.TOKEN);
};
exports.getToken = getToken;
var removeToken = function () {
    localStorage.removeItem(exports.TOKEN);
};
exports.removeToken = removeToken;
var setIsFavoriteUser = function (isFavorite) {
    localStorage.setItem('favoriteUser', String(isFavorite));
};
exports.setIsFavoriteUser = setIsFavoriteUser;
var removeIsFavoriteUser = function () {
    localStorage.removeItem('favoriteUser');
};
exports.removeIsFavoriteUser = removeIsFavoriteUser;
var getIsFavoriteUser = function () {
    return localStorage.getItem('favoriteUser') === 'true';
};
exports.getIsFavoriteUser = getIsFavoriteUser;
var checkDeveloperSettingsValidation = function (user) {
    var _a, _b;
    return !!(((_a = user === null || user === void 0 ? void 0 : user.developers[0]) === null || _a === void 0 ? void 0 : _a.developer_media.length) &&
        ((_b = user === null || user === void 0 ? void 0 : user.developers[0]) === null || _b === void 0 ? void 0 : _b.date_of_establishment));
};
exports.checkDeveloperSettingsValidation = checkDeveloperSettingsValidation;
